/*
 * @Author: Erlin
 * @CreateTime: 2020-10-14 19:41:44
 * @LastEditors: Erlin
 * @LastEditTime: 2020-10-17 15:41:42
 * @Description: 图片
 */
import RootSrore from './create'
const { $global } = RootSrore
export default {
  /** 首页文章固定图片 */
  about1: `${$global.static}/about/about-1.png`,
  about2: `${$global.static}/about/about-2.png`,
  about3: `${$global.static}/about/about-3.png`,
  about4: `${$global.static}/about/about-4.jpg`,
  about5: `${$global.static}/about/about-5.jpg`,

  alert: `${$global.static}/images/all_alert.png`,
  coupon_refund_pop_header_bg: `${$global.static}/images/my/coupon/coupon-refund-cloud-bg-pc.svg`,

  /** 画画课手指 */
  finger: `${$global.static}/icon/finger-icon.png`,
  beian: `${$global.static}/icon/beian.png`,
  /** 全阶课手指 */
  fullFinger: `${$global.static}/icon/finger.png`,
  fullFingerActive: `${$global.static}/icon/finger-active.png`,
  /** footer 公众号新浪微博 */
  wx: `${$global.static}/images/wx_code.jpeg`,
  xl: `${$global.static}/images/xl_code.jpeg`,
  title: `${$global.static}/images/title.png`,
  pc_login_logo: `${$global.static}/logo/pc_login_logo_sel_slogn_im.png`,
  logo: `${$global.static}/images/logo.svg`,
  null: `${$global.static}/images/null.png`,
  uploadError: `${$global.static}/images/upload-error.png`,

  // seals
  order_handle_no_suc_im: `${$global.static}/images/order/order_handle_no_suc_im.png`,
  order_handle_suc_im: `${$global.static}/images/order/order_handle_suc_im.png`,
  order_not_claimed_im: `${$global.static}/images/order/order_not_claimed_im.png`,
  order_received_im: `${$global.static}/images/order/order_received_im.png`,

  logo_ten_year: `${$global.static}/images/logo-ten-year.png`,
  photo_ten_year: `${$global.static}/images/photo-ten-year.png`,
  photo_ten_year_svg: `${$global.static}/images/photo-ten-year.svg`,

  /** 个人信息 */
  pc_mine_bg_ele: `${$global.static}/images/userCenter/pc/pc_mine_bg_ele.png`,
  pc_mine_bs_bgele: `${$global.static}/images/userCenter/pc/pc_mine_bs_bgele.png`,
  pc_mine_tb_bgele: `${$global.static}/images/userCenter/pc/pc_mine_tb_bgele.png`,
  pc_mine_attend_class_im: `${$global.static}/images/userCenter/pc/pc_mine_attend_class_im.png`,
  pc_mine_order_im: `${$global.static}/images/userCenter/pc/pc_mine_order_im.png`,

  /** 小程序入口 */
  weapp_entrance: `${$global.static}/images/weapp_2021_entrance.png`,
  giftIcon: `${$global.static}/icon/gift-icon.png`,
  questionIcon: `${$global.static}/icon/question-icon.png.png`,
  // 回顾
  review: `${$global.static}/course/review.png`,
  /** 视频播放背景图片 */
  videoBg: `${$global.static}/background/video-bg.png`,

  /** payment支付页面 */
  wxPay: `${$global.static}/images/wx-pay.png`,
  wxPayActive: `${$global.static}/images/wx-pay-active.png`,
  alPay: `${$global.static}/images/al-pay.png`,
  alPayActive: `${$global.static}/images/al-pay-active.png`,

  /** 侧边栏微信客服返回顶部 */
  wxLogo: `${$global.static}/icon/wx-logo.png`,
  service: `${$global.static}/icon/service.png`,
  backTop: `${$global.static}/icon/back-top.png`,
  /** 错误图片 */
  error: `${$global.static}/images/error.png`,
  /** 加载动画 */
  loading: `${$global.static}/images/loading.gif`,
  /** 首页文房图片 */
  stationery: `${$global.static}/images/stationery.png`,
  /** 助教 */
  assistant: `${$global.static}/images/assistant.jpg`,
  /** 协议icon */
  protocol: `${$global.static}/images/protocol-icon.png`,
  /** 加群qrcode */
  groupQrcode: `${$global.static}/images/group-qrcode.png`,
  groupQrcodeFive: `${$global.static}/images/group-qrcode-five.jpg`,
  rumenJichuQrcode: `${$global.static}/images/qrcode/2022_rumen_jichu.png`,
  /**  日课 **/
  dayClassTong: `${$global.static}/images/tong_hd.jpg`, //投票成功，童的二维码
  wxChart: `${$global.static}/images/clock_in_im.png`,
  /** 日课弹窗 **/
  jinyu_im: `${$global.static}/images/jinyu_im.png`,

  day_class_guide_im: `${$global.static}/images/day_class_guide_im.png`,

  exhibition_to_prepare_show_im: `${$global.static}/images/exhibition_to_prepare_show_im.png`,

  /* 积分 */
  bishan_ic: `${$global.static}/points/bishan_ic.png`,
  bishan_ic_gray: `${$global.static}/points/bishan_ic_gray.png`,
  copy_ic: `${$global.static}/points/copy_ic.png`,
  tongban_ic: `${$global.static}/points/tongban_ic.png`,
  integral_icpc: `${$global.static}/points/integral_icpc.png`,
  details_ic: `${$global.static}/points/details_ic.png`,
  erweima: `${$global.static}/points/erweima.png`,
  ticket_ic: `${$global.static}/points/ticket_ic.png`,
  _integral_binding_im: `${$global.static}/points/_integral_binding_im.png`,
  wenfang_ticket: `${$global.static}/points/wenfang_ticket.png`,
  xt_wenfang: `${$global.static}/points/xt_wenfang.png`,
  integral_binding_pcim: `${$global.static}/points/integral_binding_pcim-v3.png`,

  about_top_ele: `${$global.static}/images/about_top_ele.png`,
  about_cen_ele: `${$global.static}/images/about_cen_ele.png`,
  about_bot_ele_all: `${$global.static}/images/about_bot_ele_all.png`,
  wf_jean_bg_ele: `${$global.static}/images/wf_jean_bg_ele.png`,
  about_xt_im01: `${$global.static}/images/about_xt_im01.png`,

  about_bushan_im: `${$global.static}/images/about_bushan_im.png`,
  about_brush_im: `${$global.static}/images/about_brush_im.png`,
  wx_code: `${$global.static}/images/wx_code.jpeg`,
  about_xt_im02: `${$global.static}/images/about_xt_im02.png`,
  lx: `${$global.static}/images/lx.png`,
  about_linxi_im: `${$global.static}/images/about_linxi_im.png`,

  xl_code: `${$global.static}/images/xl_code.jpeg`,
  wf_logo_im: `${$global.static}/images/wf_logo_im.png`,
  wf_monkey_bg_ele: `${$global.static}/images/wf_monkey_bg_ele.png`,
  wf_monkey_hand_ele: `${$global.static}/images/home_wf_hand_ele.png`,
  wf_monkey_ele: `${$global.static}/images/wf_monkey_ele.png?1`,
  wf_mp: `${$global.static}/images/wf_mp.png`,
  xt_wf_pic: `${$global.static}/images/wf_banner_im.png`,
  wecom_temp_5146396cdf04325322b84fbd80eab542: `${$global.static}/images/wecom-temp-5146396cdf04325322b84fbd80eab542.jpg`,
  classmate_top_ele: `${$global.static}/images/classmate_top_ele.png`,
  classmate_cen_ele: `${$global.static}/images/classmate_cen_ele.png`,
  share_left_ele: `${$global.static}/images/share_left_ele.png`,
  share_right_ele: `${$global.static}/images/share_right_ele.png`,
  home_banner_im: `${$global.static}/images/home_banner_im.png`,
  hotIcon: `${$global.static}/images/home/fire_stroke_im.png`,
  home_collage_im: `${$global.static}/images/home/home_collage_im.png`,
  home_list_collage_pcim: `${$global.static}/images/home/home_list_collage_pcim.png`,
  fire_stroke_im: `${$global.static}/images/home/fire_stroke_im.png`,

  public_class_bot_ele: `${$global.static}/images/public_class_bot_ele.png`,
  public_class_top_ele: `${$global.static}/images/public_class_top_ele.png`,
  about_lx_im01: `${$global.static}/images/about_lx_im01.png`,
  about_lx_im02: `${$global.static}/images/about_lx_im02.png`,
  about_lx_im03: `${$global.static}/images/about_lx_im03.png`,
  xt_logo: `${$global.static}/images/xt-logo.png`,
  xt_logo_green: `${$global.static}/images/xt_logo_green.png`,
  logo_ten_year_ten: `${$global.static}/images/logo_imsel_10th .png`,
  th_logo_imnor10: `${$global.static}/images/logo_imnor_10th.png`,
  nav_day_class_im: `${$global.static}/images/svg/nav_day_class_im.svg`,

  nav_exhibition_im: `${$global.static}/images/svg/nav_exhibition_im.svg`,
  wx_rk_code: `${$global.static}/images/qrcode/wx_rk_code.jpg`,
  lx_qrcode: `${$global.static}/images/qrcode/lx_qrcode.jpg?1`,
  // logo_no_slogn_im: `${$global.static}/images/logo_no_slogn_im.png`,
  // logo_sel_slogn_im: `${$global.static}/images/logo_sel_slogn_im.png`,
  pc_logo_no_slogn_im: `${$global.static}/logo/pc_logo_no_slogn_im.png`,
  pc_logo_sel_slogn_im: `${$global.static}/logo/logo_sel_im.png`,
  live2_bg_ele: `${$global.static}/images/live_%20bg_ele02.png`,
  live1_bg_ele: `${$global.static}/images/live_%20bg_ele01.png`,
  home_exh_applet_im_bg: `${$global.static}/images/home_exh_applet_im_bg.jpg`,
  live_all_exh_course_ele01: `${$global.static}/course/detail/live_all_exh_course_ele01.png`,
  live_bg_01: `${$global.static}/images/activitys/paint_upgrade_2024/pc/live1-bg.png`,
  all_exhpc_pop_topim: `${$global.static}/course/detail/all_exhpc_pop_topim.png`,
  all_exhpc_pop_topim_money: `${$global.static}/course/detail/all_exhpc_pop_topim_money.png`,
  all_exhpc_pop_topim_gift: `${$global.static}/course/detail/all_exhpc_pop_topim_gift.png`,
  home_all_course_ele: `${$global.static}/course/detail/home_all_course_ele.png`,
  home_all_course_ele_v2: `${$global.static}/images/activitys/paint_basic_2024/pc/home_all_course_ele_v2.png`,
  popu_apply_all_im: `${$global.static}/images/popu_apply_all_im.jpg`,
  popu_apply_entrance_pc: `${$global.static}/images/popu_apply_entrance_pc_v2.gif`,
  cancellation_pc_bg: `${$global.static}/images/logout/cancellation_pc_bg.png`,
  cancel_pcele_line: `${$global.static}/images/logout/cancel_pcele_line.png`,
  cancellation_pc_bg01: `${$global.static}/images/logout/cancellation_pc_bg01.png`,

  map_write_text_1: `${$global.static}/images/home/map/map_write_text_1%402x.png`,
  map_write_text_0: `${$global.static}/images/home/map/map_write_text_0%402x.png`,
  map_write_location_ic: `${$global.static}/images/home/map/map_write_location_ic%402x.png`,
  map_write_content: `${$global.static}/images/home/map/map_write_content%402x.png`,
  map_exhibition_content: `${$global.static}/images/home/map/map_exhibition_content%402x.png`,
  map_draw_content: `${$global.static}/images/home/map/map_draw_content%402x.png`,
  map_day_class_content: `${$global.static}/images/home/map/map_day_class_content_v2.png`,

  // 首页图片中字体需要修改
  map_day_class_content_new: `${$global.static}/images/home/map/map_day_class_content.png`,
  map_draw_content_new: `${$global.static}/images/home/map/map_draw_content.png`,
  map_exhibition_content_new: `${$global.static}/images/home/map/map_exhibition_content.png`,
  map_write_content_new: `${$global.static}/images/home/map/map_write_content.png`,
  map_zero_base_text: `${$global.static}/images/home/map/map_zero_base_text-v2.png`,
  map_advanced_text: `${$global.static}/images/home/map/map_advanced_text-v2.png`,
  map_high_level_text: `${$global.static}/images/home/map/map_high_level_text-v2.png`,

  map_dragonfly_ele: `${$global.static}/images/home/map/map_dragonfly_ele%402x.png`,
  map_bg_ele03: `${$global.static}/images/home/map/map_bg_ele03%402x.png`,
  map_bg_ele01: `${$global.static}/images/home/map/map_bg_ele01%402x.png`,

  /** 去上课 */
  all_exhpc_pop_topim_go: `${$global.static}/images/goCourse/all_exhpc_pop_topim.png`,
  calendar_live_ic: `${$global.static}/images/goCourse/calendar/calendar_live_ic.png`,
  calendar_have_a_class_im: `${$global.static}/images/goCourse/calendar/calendar_have_a_class_im.png`,
  calendar_past_have_a_class_im: `${$global.static}/images/goCourse/calendar/calendar_past_have_a_class_im.png`,
  login_agree_nor: `${$global.static}/images/goCourse/pc/login_agree_nor.png`,
  login_agree_sel: `${$global.static}/images/goCourse/pc/login_agree_sel.png`,
  assistant_one_im: `${$global.static}/images/goCourse/pc/assistant_one_im.png`,
  assistant_two_im: `${$global.static}/images/goCourse/pc/assistant_two_im.png`,
  assistant_bottom_im: `${$global.static}/images/goCourse/pc/assistant_bottom_im.png`,
  intergral_exchange02_bgpc: `${$global.static}/points/intergral_exchange02_bgpc.png`,
  attend_class_empty_none_pcim: `${$global.static}/images/goCourse/pc/attend_class_empty_none_pcim.png`,

  /** 学习日历 */
  live_today_course_ic: `${$global.static}/images/goCourse/calendar/live_today_course_ic.png`,

  /**赠课 */
  give_class_no: `${$global.static}/images/give_class_no.png`,
  give_class_no_new: `${$global.static}/images/give_class_no_new.png`,

  /** 二维码 **/
  exhibitionQrCode: `${$global.static}/images/qrcode/xt_show_weapp_code.png`, //展览辅导课
  goCourse: `${$global.static}/images/goCourse/lQLPDhsy1XXr9qvNAZDNAZCwyihLIq80JJ8CI_WXUsBxAA.png`, //教练日课

  /** 支付成功 */
  payment_succeeded_tex_im_pc: `${$global.static}/images/payment/pc/payment_succeeded_tex_im_pc.png`,
  payment_succeeded_tex_im_pc_sex: `${$global.static}/images/payment/pc/payment_succeeded_tex_im_sex.png`,
  payment_succeeded: `${$global.static}/images/payment/payment_succeeded.gif`,
  payment_succeeded_bg_ele: `${$global.static}/images/payment/pc/payment_succeeded_bg_ele.png`,
  payment_im_succeeded_pc_dj: `${$global.static}/images/payment/pc/payment_im_succeeded_pc_dj.png`,
  payment_im_succeeded_pc_qj: `${$global.static}/images/payment/pc/payment_im_succeeded_pc_qj.png`,

  /** 支付页面 */
  alipay_nor_im: `${$global.static}/images/payment/pc/alipay_nor_im.png`,
  alipay_sel_im: `${$global.static}/images/payment/pc/alipay_sel_im.png`,
  gift_coloured_ribbon_pcim: `${$global.static}/images/payment/pc/gift_coloured_ribbon_pcim.png`,
  gift_ropen_sel_pcim: `${$global.static}/images/payment/pc/gift_ropen_sel_pcim.png`,
  gift_rope_sel_pcim: `${$global.static}/images/payment/pc/gift_rope_sel_pcim.png`,
  order_received_pcim: `${$global.static}/images/payment/pc/order_received_pcim.png`,
  wechat_nor_im: `${$global.static}/images/payment/pc/wechat_nor_im.png`,
  wechat_sel_im: `${$global.static}/images/payment/pc/wechat_sel_im.png`,
  payment_choice_nor_ic: `${$global.static}/images/payment/pc/payment_choice_nor_ic.png`,
  payment_choice_sel_ic: `${$global.static}/images/payment/pc/payment_choice_sel_ic.png`,
  gift_icon_im: `${$global.static}/images/payment/pc/gift_icon_im.png`,
  day_class_clock_bg: `${$global.static}/images/payment/pc/day_class_clock_bg.png`,

  payment_choice_nor_ic_new: `${$global.static}/images/payment/pc/payment_choice_nor_ic_new.png`,
  payment_choice_sel_ic_new: `${$global.static}/images/payment/pc/payment_choice_sel_ic_new.png`,
  alipay_nor_im_new: `${$global.static}/images/payment/pc/alipay_nor_im_new.png`,
  alipay_sel_im_new: `${$global.static}/images/payment/pc/alipay_sel_im_new.png`,
  wechat_nor_im_new: `${$global.static}/images/payment/pc/wechat_nor_im_new.png`,
  wechat_sel_im_new: `${$global.static}/images/payment/pc/wechat_sel_im_new.png`,

  gift_surprised_im: `${$global.static}/images/payment/pc/gift_surprised_im.png`,
  payment_all_course_right_bg_ele: `${$global.static}/images/payment/pc/payment_all_course_right_bg_ele.png`,
  payment_course_right_bg_ele: `${$global.static}/images/payment/pc/payment_course_right_bg_ele.png`,
  payment_lotus_left_bg_ele: `${$global.static}/images/payment/pc/payment_lotus_left_bg_ele.png`,
  payment_lotus_right_bg_ele: `${$global.static}/images/payment/pc/payment_lotus_right_bg_ele.png`,
  payment_lotus_left_bottom_bg_ele: `${$global.static}/images/payment/pc/payment_lotus_left_bottom_bg_ele.png`,
  payment_lotus_right_bottom_bg_ele: `${$global.static}/images/payment/pc/payment_lotus_right_bottom_bg_ele.png`,

  loading_gif: `${$global.static}/images/payment/loading.gif`,

  /** 礼物 */
  receive_gift_light_im: `${$global.static}/images/gift/receive_gift_light_im_v2.png`, //背景光照
  receive_gift_box_cent_bgim: `${$global.static}/images/gift/receive_gift_box_cent_bgim.png`,
  receive_gift_box_bot_bgim: `${$global.static}/images/gift/receive_gift_box_bot_bgim.png`,
  receive_gift_ribbon_im: `${$global.static}/images/gift/receive_gift_ribbon_im.png`,
  receive_gift_bowknot_im: `${$global.static}/images/gift/receive_gift_bowknot_im_v2.png`,
  gift_popover_close_ic: `${$global.static}/images/gift/popover_close_ic.png`,

  /** qrcode */
  xt_classroom_gzh: `${$global.static}/qrcode/wx_code.png`,
  xt_daily_mini: `${$global.static}/qrcode/dliay_XCX.png`,
  xt_exhibition_mini: `${$global.static}/qrcode/exhibition_XCX.png`,
  xt_wenfang_gzh: `${$global.static}/qrcode/study_GZH.png`,
  xt_wenfang_mini: `${$global.static}/qrcode/study_XCX.png`,
  xt_wenfang_coupon_mini: `${$global.static}/qrcode/xt_wenfang_coupon.png`,
  wechat_applet_ic: `${$global.static}/qrcode/wechat_applet_ic.png`,

  xt_qrcode_logo: `${$global.static}/qrcode/xt_qrcode_logo.png`,
  xt_show_qrcode_logo: `${$global.static}/qrcode/xt_show_qrcode_logo.jpg`,

  /** 注销账户冷静期 */
  mine_im_cancel_hand: `${$global.static}/images/mine_im_cancel_hand.png`,

  login_popup_agreement: `${$global.static}/agreements/login_popup_agreement.png`,

  manage_im_computer: `${$global.static}/images/my/device/manage_im_computer.png`,
  changeCheck: `${$global.static}/images/my/device/check.png`,

  giveaway_detail_person: `${$global.static}/images/gift/giveaway_detail_person.png`,
  giveaway_detail_qrcode: `${$global.static}/images/gift/giveaway_detail_qrcode.png`,

  device_full_modal_head: `${$global.static}/images/my/device/point.png`,
  all_ic_off_black: `${$global.static}/images/my/all_ic_off_black.png`,
  all_ic_off_white: `${$global.static}/images/my/all_ic_off_white.png`,
  all_ic_off_white_outlined: `${$global.static}/images/my/all_ic_off_white-outlined.png`,

  mine_im_link: `${$global.static}/images/home/header/mine_im_link.png`,
  mine_im_notice: `${$global.static}/images/home/header/mine_im_notice.png`,
  mine_im_link_light: `${$global.static}/images/home/header/mine_im_link_light.png`,
  mine_im_notice_light: `${$global.static}/images/home/header/mine_im_notice_light.png`,
  mine_im_volume: `${$global.static}/images/home/header/mine_im_volume.png`,
  mine_ic_wechat_applet_white: `${$global.static}/images/home/header/mine_ic_wechat_applet_white.png`,
  mine_im_xuantong: `${$global.static}/images/home/header/mine_im_xuantong.png`,
  mine_im_daily: `${$global.static}/images/home/header/mine_im_daily.png`,
  mine_im_exhibition: `${$global.static}/images/home/header/mine_im_exhibition.png`,
  mine_im_study: `${$global.static}/images/home/header/mine_im_study.png`,
  mine_im_xuantong_text: `${$global.static}/images/home/header/mine_im_xuantong_text.png`,
  mine_im_daily_text: `${$global.static}/images/home/header/mine_im_daily_text.png`,
  mine_im_exhibition_text: `${$global.static}/images/home/header/mine_im_exhibition_text.png`,
  mine_im_study_text: `${$global.static}/images/home/header/mine_im_study_text.png`,
  mine_im_xuantong_qrcode: `${$global.static}/images/home/header/mine_im_xuantong_qrcode.png`,
  mine_im_daily_qrcode: `${$global.static}/images/home/header/mine_im_daily_qrcode.png`,
  mine_im_exhibition_qrcode: `${$global.static}/images/home/header/mine_im_exhibition_qrcode.png`,
  mine_im_study_qrcode: `${$global.static}/images/home/header/mine_im_study_qrcode.png`,
  mine_im_art_qrcode: `${$global.static}/images/home/header/mine_im_art_qrcode.png`,
  mine_im_empty: `${$global.static}/images/home/header/mine_im_empty.png`,
  mine_im_sun_shine: `${$global.static}/images/home/header/mine_im_sun_shine.png`,
  mine_im_sun_shine_text: `${$global.static}/images/home/header/mine_im_sun_shine_text.png`,

  /** 微信验证 */
  verify_success: `${$global.static}/images/my/verify_success.png`,
  verify_failure: `${$global.static}/images/my/verify_failure.png`,

  /** 展示互动播放页 */
  gensee_video_play: `${$global.static}/images/gensee/ico_play_btn-v3.png`,
  gensee_direction_change: `${$global.static}/images/gensee/ico_direction_change.png`,
  gensee_expand_circle: `${$global.static}/images/gensee/ico_expand.png`,
  gensee_expand_exit_circle: `${$global.static}/images/gensee/ico_expand_exit.png`,
  gensee_expand: `${$global.static}/images/gensee/ico_expand_v2.png`,
  gensee_question: `${$global.static}/images/gensee/ico_question.png`,
  gensee_remind: `${$global.static}/images/gensee/ico_remind.png`,
  gensee_doc_expand: `${$global.static}/images/gensee/doc-expand-ico.png`,
  gensee_doc_deexpand: `${$global.static}/images/gensee/doc-deexpand-ico.png`,
  gensee_loading_too_long: `${$global.static}/images/gensee/page-loading-too-long-pc-v1.png`,
  gensee_other_browser: `${$global.static}/images/gensee/watch-on-other-browser-pc-v1.png`,
  gensee_same_browser: `${$global.static}/images/gensee/watch-on-same-browser-pc-v1.png`,
  gensee_empty_view_bg_01: `${$global.static}/images/gensee/empty-img-s1.png`,
  live_default_cover: `${$global.static}/images/gensee/classhour-live-default-cover.png`,
  doc_default_cover: `${$global.static}/images/gensee/doc-default-bg-img.jpg`,
  live_loading_img: `${$global.static}/images/gensee/classhour-live-loading-img.png`,
  live_loading_mask_img: `${$global.static}/images/gensee/classhour-live-loading-mask-img-v2.png`,

  paint_basic_2024_header_side: `${$global.static}/images/activitys/paint_basic_2024/pc/header-side-01.png`,

  // 老桐学优惠
  student_welfare_desc_pc: `${$global.static}/images/welfare/student_welfare_desc_pc.png`,
  student_welfare_rule: `${$global.static}/images/welfare/student_welfare_rule.png`,
  student_welfare_tag: `${$global.static}/images/welfare/student_welfare_tag.png`,
  student_welfare_tag_hover: `${$global.static}/images/welfare/student_welfare_tag_hover.png`,

  // 支付
  wechat_pay: `${$global.static}/images/order/pay/wechat-pay-ico-v1.svg`,
  ali_pay: `${$global.static}/images/order/pay/alipay-ico-v1.svg`,
  pay_select: `${$global.static}/images/order/pay/pay-select.svg`,
  pay_unselect: `${$global.static}/images/order/pay/pay-unselect.svg`,

  order_hasbuy_single_corner: `${$global.static}/images/order/pay/product-hasbuy-corner-v2.png`,

  coupon_button_bg: `${$global.static}/images/order/pay/coupon-bg-h5.svg`,
  payment_copper_ico: `${$global.static}/images/order/pay/payment-copper-icon.svg`,
  payment_welfare_coupon_ico: `${$global.static}/images/order/pay/payment-welfare-coupon-ico.svg`,
  payment_coupon_gift_ico: `${$global.static}/images/order/pay/coupon-gift-ico.svg`,
  coupon_item_available_bg: `${$global.static}/images/order/pay/coupon-avail-bg.svg`,
  coupon_item_unavailable_bg: `${$global.static}/images/order/pay/coupon-unavail-bg.svg`,
  coupon_item_corner: `${$global.static}/images/order/pay/coupon-corner-bg.svg`,
  coupon_item_checked: `${$global.static}/images/order/pay/coupon-avail-check.svg`,
  coupon_item_unchecked: `${$global.static}/images/order/pay/coupon-avail-uncheck.svg`,

  // 我的积分兑换
  point_exchange_reduction: `${$global.static}/images/my/point/point_exchange_reduction_v2.png`,
  point_exchange_discount: `${$global.static}/images/my/point/point_exchange_discount_v2.png`,
  point_exchange_course: `${$global.static}/images/my/point/point_exchange_course_v2.png`,
  point_exchange_study: `${$global.static}/images/my/point/point_exchange_study_v2.png`,
  point_exchange_companion: `${$global.static}/images/my/point/point_exchange_companion_v2.png`,
  small_cloud_white: `${$global.static}/images/my/point/small_cloud_white.png`,
  select_my_packs: `${$global.static}/images/my/point/select_my_packs.png`,
  un_select_course_svg: `${$global.static}/images/order/pay/ico-course-unselected.svg`,
  select_course_svg: `${$global.static}/images/order/pay/ico-course-selected.svg`,

  // 礼物
  gift_pop_ico: `${$global.static}/images/order/pay/gift/pc-gift-ico.png`,
  // gift_layer_0: `${$global.static}/images/order/pay/gift/pc-gift-layer-btm.png`,
  // gift_layer_1: `${$global.static}/images/order/pay/gift/pc-gift-layer-mask.png`,
  // gift_layer_2: `${$global.static}/images/order/pay/gift/pc-gift-layer-top.png`,
  // gift_layer_3: `${$global.static}/images/order/pay/gift/pc-gift-open-layer-bg.png`,
  // gift_layer_4: `${$global.static}/images/order/pay/gift/pc-gift-close-layer-bg.png`,
  question_pop_header_bg: `${$global.static}/images/order/pay/pc-pay-question-pop-header.png`,

  point_exchange_banner1: `${$global.static}/images/my/point/point_exchange_banner1.png`,

  // 首页北京站
  beijing_cover_url: `${$global.static}/images/activitys/travel_note/pc/beijing/home/home_banner_bg_im-v2.png`,
  beijing_travel_btn_im: `${$global.static}/images/activitys/travel_note/pc/beijing/home/home_travel_btn_im.png`,
  beijing_travel_map_im: `${$global.static}/images/activitys/travel_note/pc/beijing/home/home_travel_map_im-v2.png`,
  beijing_station_im: `${$global.static}/images/activitys/travel_note/pc/beijing/home/home_travel_beijing_station_im.png`,
  beijing_travel_popup_im: `${$global.static}/images/activitys/travel_note/pc/beijing/home/home_travel_popup_im.png`,
  beijing_travel_mark_im: `${$global.static}/images/activitys/travel_note/pc/beijing/home/home_travel_mark_im.png`,
  beijing_travel_text_im: `${$global.static}/images/activitys/travel_note/pc/beijing/home/home_travel_text_im.png`,

  // 回放延长卡弹窗
  studybuff_bottom_bg: `${$global.static}/images/my/coupon/studybuff/pc/bottom_bg.png`,
  studybuff_btn_disabled_im: `${$global.static}/images/my/coupon/studybuff/pc/btn_disabled_im.png`,
  studybuff_btn_enabled_im: `${$global.static}/images/my/coupon/studybuff/pc/btn_enabled_im.png`,
  studybuff_content_bg: `${$global.static}/images/my/coupon/studybuff/pc/content_bg.png`,
  studybuff_item_top_im: `${$global.static}/images/my/coupon/studybuff/pc/item_top_im.png`,
  studybuff_left_bg: `${$global.static}/images/my/coupon/studybuff/pc/left_bg.png`,
  studybuff_right_bg: `${$global.static}/images/my/coupon/studybuff/pc/right_bg.png`,
  studybuff_item_selected: `${$global.static}/images/my/coupon/studybuff/pc/item_selected.png`,

  coupon_share_popup_bg: `${$global.static}/images/my/coupon/coupon_share_popup_bg.png`,
  enter_applet_text_im: `${$global.static}/images/my/coupon/enter_applet_text_im.png`,

  gift_box_v2_bg: `${$global.static}/images/payment/pc/gift-v2-bg.png`,
  gift_box_v2_bg_close: `${$global.static}/images/payment/pc/gift-v2-bg-close.png`,
  gift_box_v2_title: `${$global.static}/images/payment/pc/gift-v2-title.png`,
  gift_receive_title: `${$global.static}/images/gift/pc/gift-receive-title.png`,
  gift_receive_name_bg: `${$global.static}/images/gift/pc/gift-receive-name-bg.png`,

  coupon_gift_top_im: `${$global.static}/images/my/coupon/gift/coupon_gift_top_im.png`,
  coupon_gift_bottom_im: `${$global.static}/images/my/coupon/gift/coupon_gift_bottom_im.png`,

  // 新的课程详情页
  dairy_tab_input_bar_ico: `${$global.static}/images/course/pc/diary-input-bar-ico.svg`,
  dairy_tab_dairy_ico: `${$global.static}/images/course/pc/diary-tab-dairy-ico.svg`,
  dairy_tab_homework_ico: `${$global.static}/images/course/pc/diary-tab-homework-ico.svg`,
  dairy_tab_lookup_ico: `${$global.static}/images/course/pc/diary-tab-lookup-ico.svg`,
  dairy_input_bar_bg: `${$global.static}/images/course/pc/dairy-input-bar-bg.png`,
  content_corner: `${$global.static}/images/course/pc/content-no-img-corner.svg`,
  dairy_input_bar_pen: `${$global.static}/images/course/pc/dairy_input_bar_pen.svg`,
  course_page_card_pen_ico: `${$global.static}/images/common-icon/icon-pen.svg`,
  join_class_ico: `${$global.static}/images/course/pc/join-group-ico.svg`,
  class_text_ico: `${$global.static}/images/course/pc/guide-grade-text-bg.svg`,
  homework_require_bg: `${$global.static}/images/course/pc/homework_require_bg-v1.png`,
  homework_material_pdf: `${$global.static}/images/common-icon/icon-file-pdf.svg`,
  homework_material_mp4: `${$global.static}/images/common-icon/icon-file-mp4.svg`,
  homework_material_mp3: `${$global.static}/images/common-icon/icon-file-mp3.svg`,
  homework_material_png: `${$global.static}/images/common-icon/icon-file-png.svg`,
  homework_material_jpg: `${$global.static}/images/common-icon/icon-file-jpg.svg`,
  homework_material_gif: `${$global.static}/images/common-icon/icon-file-gif.svg`,
  homework_material_doc: `${$global.static}/images/common-icon/icon-file-doc.svg`,
  homework_material_xls: `${$global.static}/images/common-icon/icon-file-xls.svg`,
  homework_material_ppt: `${$global.static}/images/common-icon/icon-file-ppt.svg`,
  homework_material_text: `${$global.static}/images/common-icon/icon-file-txt.svg`,
  homework_material_zip: `${$global.static}/images/common-icon/icon-file-zip.svg`,
  homework_material_unknown: `${$global.static}/images/common-icon/icon-file-unknown.svg`,
  course_ready_bg: `${$global.static}/images/course/pc/course_ready_bg.png`,
  course_ready_top_bg: `${$global.static}/images/course/pc/course_ready_top_bg.png`,
  course_ready_content_bg: `${$global.static}/images/course/pc/course_ready_content_bg.png`,
  homework_ico: `${$global.static}/images/course/pc/homework_ico.svg`,
  wenfang_ico: `${$global.static}/images/common-icon/icon-wenfang.svg`,
  material_ico: `${$global.static}/images/common-icon/icon-material.svg`,
  account_wechat_ico: `${$global.static}/images/common-icon/icon-account-wechat.svg`,
  account_phone_ico: `${$global.static}/images/common-icon/icon-account-phone.svg`,
  account_email_ico: `${$global.static}/images/common-icon/icon-account-email.svg`,
  copy_ico: `${$global.static}/images/common-icon/icon-copy.svg`,
  write_homework_ico: `${$global.static}/images/course/pc/write_homework_ico-outline.svg`,
  think_homework_ico: `${$global.static}/images/course/pc/think_homework_ico.svg`,
  homework_question_ico: `${$global.static}/images/course/pc/homework_question_ico.svg`,
  living_im: `${$global.static}/images/course/pc/living_im.png`,
  playback_generating_im: `${$global.static}/images/course/pc/playback_generating_im.png`,
  playback_end_im: `${$global.static}/images/course/pc/playback_end_im.png`,
  back_circle_btn: `${$global.static}/images/course/pc/back-circle-btn.png`,
  share_link_ico: `${$global.static}/images/course/pc/share-link-ico.svg`,
  sticker_ico: `${$global.static}/images/course/pc/sticker_ico.svg`,
  violation_ico: `${$global.static}/images/course/pc/violation_ico.svg`,
  bmrc_write_ico: `${$global.static}/images/course/pc/course-tab-write.png`,

  classhour_bishan: `${$global.static}/images/common-icon/icon-bishan.svg`,
  classhour_bishan_fill: `${$global.static}/images/common-icon/icon-bishan-fill.svg`,
  classhour_icon_tv: `${$global.static}/images/common-icon/icon-tv.svg`,

  // 引导页
  live_video_img: `${$global.static}/images/guide/pc/live/guide-material-cover-img.jpg`,
  live_material_img: `${$global.static}/images/guide/pc/live/live-material-bg.png`,
  guide_entrance_left_bg: `${$global.static}/images/guide/pc/entrance/guide-entrance-left-imgv2.png`,
  guide_entrance_tips: `${$global.static}/images/guide/pc/entrance/guide-entrance-tips.png`,
  guide_entrance_join_class: `${$global.static}/images/guide/pc/entrance/guide-entrance-join-class.png`,
  guide_entrance_grade: `${$global.static}/images/guide/pc/entrance/guide-entrance-grade.png`,
  guide_entrance_grade_text: `${$global.static}/images/guide/pc/entrance/guide-entrance-grade-text.png`,
  guide_entrance_schedule: `${$global.static}/images/guide/pc/entrance/guide-entrance-schedule.png`,
  guide_entrance_course_plan: `${$global.static}/images/guide/pc/entrance/guide-entrance-course-plan.png`,
  guide_entrance_wenfang: `${$global.static}/images/guide/pc/entrance/guide-entrance-wenfang-v2.png`,
  guide_entrance_small_sachet: `${$global.static}/images/guide/pc/entrance/guide-entrance-small-sachet.png`,
  guide_entrance_manual: `${$global.static}/images/guide/pc/entrance/manual.png`,
  guide_entrance_basic: `${$global.static}/images/guide/pc/entrance/basic.png`,
  guide_entrance_time_show: `${$global.static}/images/guide/pc/entrance/guide-entrance-time-showv3.png`,
  guide_entrance_time_slot: `${$global.static}/images/guide/pc/entrance/guide-entrance-time-slot.png`,
  guide_entrance_time_slot_afternoon: `${$global.static}/images/guide/pc/entrance/guide-entrance-time-slot-afternoon.png`,
  guide_entrance_drive_btn: `${$global.static}/images/guide/pc/entrance/guide-entrance-drive-btn.png`,
  guide_entrance_ring: `${$global.static}/images/guide/pc/entrance/guide-entrance-ringV2.png`,
  guide_joinclass_bg: `${$global.static}/images/guide/pc/entrance/joinclassmodal/joinclass-bamboo-bg.png`,
  guide_joinclass_spirit: `${$global.static}/images/guide/pc/entrance/joinclassmodal/joinclass-spirit.png`,
  guide_joinclass_close_icon: `${$global.static}/images/guide/pc/entrance/joinclassmodal/joinclass-close-icon.png`,
  guide_final_bamboo_bg: `${$global.static}/images/guide/pc/finalstep/guide-final-bamboo-bg.png`,
  guide_final_bookboy_bg: `${$global.static}/images/guide/pc/finalstep/guide-final-bookboy-bgv2.png`,
  guide_final_keepdiary: `${$global.static}/images/guide/pc/finalstep/guide-final-keepdiaryv2.png`,
  guide_final_wish_you: `${$global.static}/images/guide/pc/finalstep/guide-final-wish-you.png`,
  guide_final_add_bishan: `${$global.static}/images/guide/pc/finalstep/guide-final-add-bishan.png`,
  guide_final_sing_box_bg: `${$global.static}/images/guide/pc/finalstep/guide-final-sing.png`,
  guide_final_sing_box_bgv2: `${$global.static}/images/guide/pc/finalstep/guide-final-sing-bgimg.png`,
  guide_final_qrcode_box_bg: `${$global.static}/images/guide/pc/finalstep/guide-final-qrcode.png`,
  guide_final_show_box_bg: `${$global.static}/images/guide/pc/finalstep/guide-final-show-box-bgimg.png`,
  guide_final_plate: `${$global.static}/images/guide/pc/finalstep/guide-final-plate.png`,
  guide_final_play: `${$global.static}/images/guide/pc/finalstep/guide-final-play.png`,
  guide_final_pause: `${$global.static}/images/guide/pc/finalstep/guide-final-pause.png`,
  guide_wenfang_back_btn: `${$global.static}/images/guide/pc/entrance/wenfang/wenfang-btn.png`,
  guide_wenfang_back_box: `${$global.static}/images/guide/pc/entrance/wenfang/wenfang-box.png`,
  guide_wenfang_detail_bg: `${$global.static}/images/guide/pc/entrance/wenfang/wenfang-detail-pop-bg.png`,
  guide_wenfang_detail_line: `${$global.static}/images/guide/pc/entrance/wenfang/wenfang-detail-pop-line.png`,
  guide_wenfang_exit: `${$global.static}/images/guide/pc/entrance/wenfang/wenfang-exit-icov2.svg`,
  guide_wenfang_empty_bg: `${$global.static}/images/guide/pc/entrance/wenfang/empty-view-cover.png`,
  guide_wenfang_detail_go_svg: `${$global.static}/images/guide/pc/wenfang-detail-go-btn.svg`,
  error_status_image_icon: `${$global.static}/images/common-icon/icon-image.svg`,
  content_error_delete: `${$global.static}/images/error-status/error-0.png`,
  content_error_private: `${$global.static}/images/error-status/error-1.png`,
  content_error_delete_icon: `${$global.static}/images/common-icon/icon-delete.svg`,
  content_error_private_icon: `${$global.static}/images/common-icon/icon-lock.svg`,
  arrow_top_ic: `${$global.static}/images/common-icon/icon-arrow-top.svg`,
  add_ic: `${$global.static}/images/common-icon/icon-add.svg`,

  // 新首页图片
  hero_section_banner_bg: `${$global.static}/images/home-new/pc/hero-section-banner-bg-v4.png`,
  hero_section_banner2_bg: `${$global.static}/images/home-new/pc/hero-section-banner2-bg-v2.png`,
  hero_section_banner3_bg: `${$global.static}/images/home-new/pc/hero-section-banner3-bg-v3.png`,
  hero_section_banner4_bg: `${$global.static}/images/home-new/pc/hero-section-banner4-bg.png`,
  hero_section_banner5_bg: `${$global.static}/images/home-new/pc/hero-section-banner5-bgv2.png`,
  hero_section_banner6_bg: `${$global.static}/images/home-new/pc/hero-section-banner6-bg.png`,
  swiper_prev_btn: `${$global.static}/images/home-new/pc/swiper-prev-btn.svg`,
  swiper_next_btn: `${$global.static}/images/home-new/pc/swiper-next-btn.svg`,
  activity_clock_svg: `${$global.static}/images/home-new/pc/exh-ic-class-time.svg`,
  activity_clock_svg_gray: `${$global.static}/images/home-new/pc/exh-ic-class-time-gray.svg`,
  activity_scan_qrcode: `${$global.static}/images/home-new/pc/activity-scan-qrcode-v2.svg`,
  home_prev_btn: `${$global.static}/images/home-new/pc/home-prev-btn.svg`,
  home_next_btn: `${$global.static}/images/home-new/pc/home-next-btn.svg`,
  home_prev_btn_hover: `${$global.static}/images/home-new/pc/home-prev-btn-hover-v2.svg`,
  home_next_btn_hover: `${$global.static}/images/home-new/pc/home-next-btn-hover-v2.svg`,
  home_refresh_btn: `${$global.static}/images/home-new/pc/home-refresh-btn.svg`,
  home_title_sprites: `${$global.static}/images/home-new/pc/home-title-sprites-v5.png`,
  home_title_bmkzl: `${$global.static}/images/home-new/pc/home-title-bmkzlv2.png`,
  hello_tong_sprites: `${$global.static}/images/home-new/pc/hello-tong-sprites-v3.png`,
  live_class_sprites: `${$global.static}/images/home-new/pc/live-class-sprites.png`,
  teach_sprites: `${$global.static}/images/home-new/pc/teach_sprites.png`,
  home_live_class_bg: `${$global.static}/images/home-new/pc/live-class-bg.png`,
  home_teach_bg: `${$global.static}/images/home-new/pc/teach-bg-v3.png`,
  home_wen_fang_bg: `${$global.static}/images/home-new/pc/wen-fang-bg.png`,
  home_hello_tong_card_icon: `${$global.static}/images/home-new/pc/hello-tong-card-icon.svg`,
  article_right_top_bg: `${$global.static}/images/home-new/pc/article-right-top-bg.png`,
  article_right_bottom_bg: `${$global.static}/images/home-new/pc/article-right-bottom-bg.png`,
  article_left_top_bg: `${$global.static}/images/home-new/pc/article-left-top-bg.png`,
  article_left_bottom_bg: `${$global.static}/images/home-new/pc/article-left-bottom-bg.png`,
  company_intro_logo: `${$global.static}/images/home-new/pc/company-intro-logo.png`,
  company_intro_draw: `${$global.static}/images/home-new/pc/company-intro-draw.png`,
  company_intro_panda_side: `${$global.static}/images/home-new/pc/company-intro-panda-side.png`,
  company_intro_teacher_img: `${$global.static}/images/home-new/pc/company-intro-teacher-img.png`,
  company_intro_teacher_name: `${$global.static}/images/home-new/pc/company-intro-teacher-name-v2.png`,
  company_intro_bg_img: `${$global.static}/images/home-new/pc/company-intro-bg-img.png`,
  layout_footer_logo: `${$global.static}/images/home-new/common/icon-logo.svg`,
  layout_footer_mini: `${$global.static}/images/home-new/common/icon-mini.svg`,
  layout_footer_redbook: `${$global.static}/images/home-new/common/icon-redbook.svg`,
  layout_footer_wechat: `${$global.static}/images/home-new/common/icon-wechat.svg`,
  layout_footer_icp: `${$global.static}/images/home-new/common/icon-icp.png`,
  layout_footer_qrcode_wechat: `${$global.static}/images/home-new/pc/wechat-qrcode.png`,
  layout_footer_qrcode_mini: `${$global.static}/images/home-new/pc/mine_im_xuantong_qrcode.png`,
  layout_footer_qrcode_rebook: `${$global.static}/images/home-new/pc/redbook-qrcode-v2.png`,
  activity_head_card_img: `${$global.static}/images/home-new/pc/card-header.png`,
  activity_head_card_only_course_img: `${$global.static}/images/home-new/pc/card-header-only-course-v2.png`,
  activity_head_card_empty_img: `${$global.static}/images/home-new/pc/card-header-empty-v2.png`,
  day_head_card_img: `${$global.static}/images/home-new/pc/day-card-header.png`,
  home_head_action_sprites: `${$global.static}/images/home-new/pc/home-action-sprites.png`,
  home_head_qr_mini: `${$global.static}/images/home-new/pc/home-header-qr-mini-v2.svg`,
  home_head_qr_show: `${$global.static}/images/home-new/pc/home-header-qr-show-v2.svg`,
  home_head_qr_mini_selected: `${$global.static}/images/home-new/pc/home-header-qr-mini-selected-v2.svg`,
  home_head_qr_mini_bg_white: `${$global.static}/images/home-new/pc/home-header-qr-mini-selected-v6.svg`,
  home_head_qr_show_selected: `${$global.static}/images/home-new/pc/home-header-qr-show-selected-v2.svg`,
  home_head_qr_show_bg_white: `${$global.static}/images/home-new/pc/home-header-qr-show-selected-white.svg`,
  home_wenfang_bg_online: `${$global.static}/images/home-new/pc/wenfang-bg-online-v3.png`,
  home_wenfang_bg_offline: `${$global.static}/images/home-new/pc/wenfang-bg-offline.png`,
  home_wenfang_qrcode_online: `${$global.static}/images/home-new/pc/home-wenfang-qrcode-on-img.svg`,
  home_wenfang_qrcode_offline: `${$global.static}/images/home-new/pc/home-wenfang-qrcode-off-img.svg`,
  home_hello_tong_qrcode: `${$global.static}/images/home-new/pc/hello-tong-qrcode-v3.png`,
  home_live_today_course: `${$global.static}/images/home-new/pc/live-today-course-ic-v2.svg`,
  home_new_course_pop_top_bg: `${$global.static}/images/home-new/pc/home-new-course-pop-top-bg-v2.png`,
  home_new_course_pop_bottom_bg: `${$global.static}/images/home-new/pc/home-new-course-pop-bottom-bg-v2.png`,

  // 新同学请了解
  about_xuantong_hero_section_bg: `${$global.static}/images/about-xuantong/pc/about-xuantong-hero-section-bg-v3.png`,
  about_xuantong_character: `${$global.static}/images/about-xuantong/pc/about-xuantong-character-v2.png`,
  about_xuantong_hero_section_title: `${$global.static}/images/about-xuantong/pc/about-xuantong-hero-section-title.png`,
  about_xuantong_hero_section_content_img: `${$global.static}/images/about-xuantong/pc/about-xuantong-hero-section-content-img-v2.png`,
  about_xuantong_hero_section_line: `${$global.static}/images/about-xuantong/pc/about-xuantong-hero-section-line.png`,
  about_xuantong_about_title: `${$global.static}/images/about-xuantong/pc/about-xuantong-about-title.png`,
  about_xuantong_about_describe: `${$global.static}/images/about-xuantong/pc/about-xuantong-about-describe.png`,
  about_xuantong_about_content_img: `${$global.static}/images/about-xuantong/pc/about-xuantong-about-content-img-v3.png`,
  about_xuantong_about_tabs_img: `${$global.static}/images/about-xuantong/pc/about-xuantong-about-tabs-sprites-v3.png`,
  about_xuantong_about_tabs_container_bm: `${$global.static}/images/about-xuantong/pc/about-tabs-content-bg-bm-v3.png`,
  about_xuantong_tong_tabs_bm_img: `${$global.static}/images/about-xuantong/pc/about-xuantong-wish-bg-v2.jpg`,
  about_xuantong_about_tabs_container_jxtx: `${$global.static}/images/about-xuantong/pc/about-tabs-content-bg-jxtx-v4.png`,
  about_xuantong_about_tabs_container_kczc: `${$global.static}/images/about-xuantong/pc/about-tabs-content-bg-kczc-v2.png`,
  about_xuantong_about_tabs_container_kcxz: `${$global.static}/images/about-xuantong/pc/about-tabs-content-bg-kcxz-v3.png`,
  about_xuantong_about_tabs_container_show: `${$global.static}/images/about-xuantong/pc/about-tabs-content-bg-show-v2.png`,
  about_xuantong_about_content_self_qrcode: `${$global.static}/images/about-xuantong/pc/about-tabs-content-self-qrcode.png`,
  about_xuantong_about_content_show_qrcode: `${$global.static}/images/about-xuantong/pc/about-tabs-content-show-qrcode.png`,
  about_xuantong_about_content_yj_qrcode: `${$global.static}/images/about-xuantong/pc/about-tabs-content-yj-qrcode-v2.png`,
  about_xuantong_tong_xue_title: `${$global.static}/images/about-xuantong/pc/about-xuantong-tong-xue-title-v2.png`,
  about_xuantong_tong_xue_shkq_bg: `${$global.static}/images/about-xuantong/pc/about-xuantong-tong-xue-shkq-bg-v2.png`,
  about_xuantong_tong_xue_txyh_bg: `${$global.static}/images/about-xuantong/pc/about-xuantong-tong-xue-txyh-bg-v2.png`,
  about_xuantong_tong_activity_title: `${$global.static}/images/about-xuantong/pc/about-xuantong-activity-title-bg-v2.png`,
  about_xuantong_tong_activity_rally_describe: `${$global.static}/images/about-xuantong/pc/about-xuantong-activity-rally-describe.png`,
  about_xuantong_tong_activity_rally_content_img: `${$global.static}/images/about-xuantong/pc/about-xuantong-activity-rally-content-img-v2.png`,
  about_xuantong_tong_activity_rally_show_img: `${$global.static}/images/about-xuantong/pc/about-xuantong-activity-rally-show-img-v2.png`,
  about_xuantong_tong_activity_xtyh_img: `${$global.static}/images/about-xuantong/pc/about-xuantong-activity-xtyh-img.png`,
  about_xuantong_tong_more_title_img: `${$global.static}/images/about-xuantong/pc/about-xuantong-more-title-img.png`,
  about_xuantong_tong_more_bg_img: `${$global.static}/images/about-xuantong/pc/about-xuantong-more-bg-img.png`,
  about_xuantong_tong_more_content_bg_img: `${$global.static}/images/about-xuantong/pc/about-xuantong-more-content-bg-img-v2.png`,
  about_xuantong_tong_more_content_bmkc: `${$global.static}/images/about-xuantong/pc/about-xuantong-more-content-bmkc.svg`,
  about_xuantong_tong_more_content_xssc: `${$global.static}/images/about-xuantong/pc/about-xuantong-more-content-xssc.svg`,
  about_xuantong_tong_more_content_basic: `${$global.static}/images/about-xuantong/pc/about-xuantong-more-content-basic.svg`,
  about_xuantong_tong_more_content_inspiration: `${$global.static}/images/about-xuantong/pc/about-xuantong-more-content-inspiration.svg`,
  about_xuantong_tong_more_content_video: `${$global.static}/images/about-xuantong/pc/about-xuantong-more-content-video.svg`,
  about_xuantong_tong_more_content_book: `${$global.static}/images/about-xuantong/pc/about-xuantong-more-content-book.svg`,
  about_xuantong_tong_more_how_register_item1: `${$global.static}/images/about-xuantong/pc/about-xuantong-more-content-book.svg`,
  about_xuantong_tong_more_bottom_bg: `${$global.static}/images/about-xuantong/pc/more-wrapper-bootm-bg.png`,
  about_xuantong_tong_more_content_bottom_bg: `${$global.static}/images/about-xuantong/pc/about-xuantong-more-bg-img-v2.png`,

  // 公开课
  video_page_title: `${$global.static}/images/video-page-title.png`,

  // 帮助中心
  chapter_icon: `${$global.static}/images/books/static/chapter-indicator.png`,
  help_tabs_img: `${$global.static}/images/books/static/help-tabs-sprites-v4.png`,
  help_menu_footer_bg: `${$global.static}/images/books/static/chapter-toc-footer-bg.png`,
  help_menu_fold: `${$global.static}/images/books/static/books-return-icon-v2.svg`,
  help_menu_fold_selected: `${$global.static}/images/books/static/books-return-icon-selected-v2.svg`,

  // 联系我们
  protocol_contact_title_sprites: `${$global.static}/images/protocol/pc/protocol-contact-title-sprites.png`,
  protocol_contact_bg_img: `${$global.static}/images/protocol/pc/protocol-contact-bg-img.png`,
  protocol_feedback_bg_img: `${$global.static}/images/protocol/pc/protocol-feedback-bg-img-v4.png`,

  // 产品页
  product_classify_bg_img1: `${$global.static}/images/product/classify-bg-img1.png`,
  product_classify_bg_img2: `${$global.static}/images/product/classify-bg-img2.png`,

  // 详情页异常图
  empty_status_no_result_data: `${$global.static}/images/empty-status/no_result_data_208_120.png`,
  empty_status_page_not_found: `${$global.static}/images/empty-status/page_not_found_240_176.png`,
  empty_status_no_wenfang_item: `${$global.static}/images/empty-status/no_wenfang_item_149_133.png`,
  empty_status_no_download_file: `${$global.static}/images/empty-status/no_download_file_144_133.png`,
  empty_status_network_error: `${$global.static}/images/empty-status/network_error_280_150.png`,
  empty_status_homework_not_publish: `${$global.static}/images/empty-status/homework_not_publish_208_135.png`,
  empty_status_no_result_data_nolist: `${$global.static}/images/empty-status/no_course_data_234_167.png`,

  // 学习小结
  study_summary_header_bird: `${$global.static}/images/study-summary/study-summary-header-bird.svg`,
  study_summary_music_play_img: `${$global.static}/images/study-summary/music-player-img-v3.png`,
  study_summary_music_musicalNote_img: `${$global.static}/images/study-summary/music-musicalNote-img.png`,
  study_summary_music_musicalNote02_img: `${$global.static}/images/study-summary/music-musicalNote2-img.gif`,
  study_summary_header_bg: `${$global.static}/images/study-summary/study-summary-header-bg-v2.png`,
  study_summary_title_sprites: `${$global.static}/images/study-summary/study-summary-title-sprites.png`,
  study_summary_homework_empty: `${$global.static}/images/study-summary/study-summary-homework-empty.png`,
  study_summary_homework_card_text_empty: `${$global.static}/images/study-summary/study-summary-homework-card-text-empty.png`,
  study_summary_homework_card_img_empty: `${$global.static}/images/study-summary/study-summary-homework-card-img-empty-v3.png`,
  study_summary_action_title_sprites: `${$global.static}/images/study-summary/summary-action-data-sprites-v2.png`,
  study_summary_action_message_sprites: `${$global.static}/images/study-summary/study-action-data-message-sprites.png`,
  study_summary_process_completion_img: `${$global.static}/images/study-summary/study-process-completion-img.png`,
  study_summary_process_titles_sprites: `${$global.static}/images/study-summary/study-process-titles-sprites-v2.png`,
  study_summary_process_bottom_bg: `${$global.static}/images/study-summary/study-process-bottom-bg.png`,
  study_summary_process_bottom_message_sprites: `${$global.static}/images/study-summary/study-process-bottom-message-sprites.png`,
  study_summary_process_teacher_img: `${$global.static}/images/study-summary/study-process-teacher-img.png`,
  study_summary_process_cat: `${$global.static}/images/study-summary/study-process-cat.png`,
  study_summary_dairy_like_svg: `${$global.static}/images/study-summary/study-summary-like.svg`,
  study_summary_dairy_comment_svg: `${$global.static}/images/study-summary/study-summary-comment.svg`,
  study_summary_dairy_collect_svg: `${$global.static}/images/study-summary/study-summary-collect.svg`,
  study_summary_dairy_card_top_img: `${$global.static}/images/study-summary/study-summary-dairy-card-top-img.png`,
  study_summary_dairy_card_bottom_img: `${$global.static}/images/study-summary/study-summary-dairy-card-bottom-img.png`,
  study_summary_dairy_card_text_empty: `${$global.static}/images/study-summary/study-summary-dairy-card-text-empty.png`,
  study_summary_dairy_card_img_empty: `${$global.static}/images/study-summary/study-summary-dairy-card-img-empty.png`,
  study_summary_dairy_card_list_empty: `${$global.static}/images/study-summary/study-summary-dairy-card-list-empty.png`,
  study_summary_record_bgimg: `${$global.static}/images/study-summary/study-summary-record-bgimg.png`,
  study_summary_record_star: `${$global.static}/images/study-summary/study-summary-record-star.svg`,
  study_summary_record_clip: `${$global.static}/images/study-summary/study-summary-record-clip.svg`,
  study_summary_record_card01_top_bgimg: `${$global.static}/images/study-summary/stduy-summary-record-card-t1-light.png`,
  study_summary_record_card01_bottom_bgimg: `${$global.static}/images/study-summary/stduy-summary-record-card-t1-moon.png`,
  study_summary_record_card01_textimg: `${$global.static}/images/study-summary/stduy-summary-record-card-t1-text-v2.png`,
  study_summary_record_card02_top_bgimg: `${$global.static}/images/study-summary/stduy-summary-record-card-t2-team-v2.png`,
  study_summary_record_card02_bottom_bgimg: `${$global.static}/images/study-summary/stduy-summary-record-card-t2-person-v2.png`,
  study_summary_record_card02_textimg: `${$global.static}/images/study-summary/stduy-summary-record-card-t2-text-v3.png`,
  study_summary_record_card03_top_bgimg: `${$global.static}/images/study-summary/stduy-summary-record-card-t3-heart.png`,
  study_summary_record_card03_bottom_bgimg: `${$global.static}/images/study-summary/stduy-summary-record-card-t3-duck-v2.png`,
  study_summary_record_card03_textimg: `${$global.static}/images/study-summary/stduy-summary-record-card-t3-text-v2.png`,
  study_summary_record_card04_tbg: `${$global.static}/images/study-summary/stduy-summary-record-card-t4-tbg.png`,
  study_summary_record_card04_bbg: `${$global.static}/images/study-summary/stduy-summary-record-card-t4-bbg.png`,
  study_summary_record_card04_tg: `${$global.static}/images/study-summary/stduy-summary-record-card-t4-tg.png`,
  study_summary_record_card05_tbg: `${$global.static}/images/study-summary/stduy-summary-record-card-t5-tbg.png`,
  study_summary_record_card05_bbg: `${$global.static}/images/study-summary/stduy-summary-record-card-t5-bbg.png`,
  study_summary_record_card05_tg: `${$global.static}/images/study-summary/stduy-summary-record-card-t5-tg.png`,
  study_summary_record_card06_tbg: `${$global.static}/images/study-summary/stduy-summary-record-card-t6-tbg.png`,
  study_summary_record_card06_bbg: `${$global.static}/images/study-summary/stduy-summary-record-card-t6-bbg.png`,
  study_summary_record_card06_tg: `${$global.static}/images/study-summary/stduy-summary-record-card-t6-tg.png`,
  study_summary_record_card07_tbg: `${$global.static}/images/study-summary/stduy-summary-record-card-t7-tbg.png`,
  study_summary_record_card07_bbg: `${$global.static}/images/study-summary/stduy-summary-record-card-t7-bbg.png`,
  study_summary_record_card07_tg: `${$global.static}/images/study-summary/stduy-summary-record-card-t7-tg.png`,
  study_summary_record_card08_tbg: `${$global.static}/images/study-summary/stduy-summary-record-card-t8-tbg.png`,
  study_summary_record_card08_bbg: `${$global.static}/images/study-summary/stduy-summary-record-card-t8-bbg.png`,
  study_summary_record_card08_tg: `${$global.static}/images/study-summary/stduy-summary-record-card-t8-tg.png`,
  study_summary_record_card09_tbg: `${$global.static}/images/study-summary/stduy-summary-record-card-t9-tbg.png`,
  study_summary_record_card09_bbg: `${$global.static}/images/study-summary/stduy-summary-record-card-t9-bbg.png`,
  study_summary_record_card09_tg: `${$global.static}/images/study-summary/stduy-summary-record-card-t9-tg.png`,
  study_summary_record_card10_tbg: `${$global.static}/images/study-summary/stduy-summary-record-card-t10-tbg.png`,
  study_summary_record_card10_bbg: `${$global.static}/images/study-summary/stduy-summary-record-card-t10-bbg.png`,
  study_summary_record_card10_tg: `${$global.static}/images/study-summary/stduy-summary-record-card-t10-tg.png`,
  study_summary_record_card11_tbg: `${$global.static}/images/study-summary/stduy-summary-record-card-t11-tbg.png`,
  study_summary_record_card11_bbg: `${$global.static}/images/study-summary/stduy-summary-record-card-t11-bbg.png`,
  study_summary_record_card11_tg: `${$global.static}/images/study-summary/stduy-summary-record-card-t11-tg.png`,
  study_summary_record_card12_tbg: `${$global.static}/images/study-summary/stduy-summary-record-card-t12-tbg.png`,
  study_summary_record_card12_bbg: `${$global.static}/images/study-summary/stduy-summary-record-card-t12-bbg.png`,
  study_summary_record_card12_tg: `${$global.static}/images/study-summary/stduy-summary-record-card-t12-tg.png`,
  study_summary_record_card13_tbg: `${$global.static}/images/study-summary/stduy-summary-record-card-t13-tbg.png`,
  study_summary_record_card13_bbg: `${$global.static}/images/study-summary/stduy-summary-record-card-t13-bbg.png`,
  study_summary_record_card13_tg: `${$global.static}/images/study-summary/stduy-summary-record-card-t13-tg.png`,
  study_summary_record_card14_tbg: `${$global.static}/images/study-summary/stduy-summary-record-card-t14-tbg.png`,
  study_summary_record_card14_bbg: `${$global.static}/images/study-summary/stduy-summary-record-card-t14-bbg.png`,
  study_summary_record_card14_tg: `${$global.static}/images/study-summary/stduy-summary-record-card-t14-tg.png`,
  study_summary_record_card15_tbg: `${$global.static}/images/study-summary/stduy-summary-record-card-t15-tbg.png`,
  study_summary_record_card15_bbg: `${$global.static}/images/study-summary/stduy-summary-record-card-t15-bbg.png`,
  study_summary_record_card15_tg: `${$global.static}/images/study-summary/stduy-summary-record-card-t15-tg.png`,
  study_summary_record_card16_bg: `${$global.static}/images/study-summary/stduy-summary-record-card-t16.png`,
  study_summary_record_card17_bg: `${$global.static}/images/study-summary/stduy-summary-record-card-t17.png`,
  study_summary_record_card18_bg: `${$global.static}/images/study-summary/stduy-summary-record-card-t18.png`,
  study_summary_modal_bottom_bgimg: `${$global.static}/images/study-summary/stduy-summary-bottom-bgimg-v2.png`,
  study_summary_record_bgimg_left: `${$global.static}/images/study-summary/stduy-summary-record-left-slot-img.png`,
  study_summary_record_bgimg_center: `${$global.static}/images/study-summary/stduy-summary-record-center-slot-img.png`,
  study_summary_record_bgimg_right: `${$global.static}/images/study-summary/stduy-summary-record-right-slot-img.png`,
  study_shared_modal_top_bgimg: `${$global.static}/images/study-summary/study-shared-modal-top-bg-img.png`,
  study_shared_modal_top_birdimg: `${$global.static}/images/study-summary/study-shared-modal-top-bird-img-v2.png`,
  study_shared_modal_bottom_butterflyimg: `${$global.static}/images/study-summary/study-shared-modal-bottom-butterfly-img-v2.png`,
  study_shared_modal_record_title: `${$global.static}/images/study-summary/study-shared-modal-record-title-img.png`,
  study_shared_modal_record_item01: `${$global.static}/images/study-summary/study-shared-modal-record-item01.png`,
  study_shared_modal_record_item02: `${$global.static}/images/study-summary/study-shared-modal-record-item02.png`,
  study_shared_modal_record_item03: `${$global.static}/images/study-summary/study-shared-modal-record-item03.png`,
  study_shared_modal_record_item04: `${$global.static}/images/study-summary/study-shared-modal-record-item04.png`,
  study_shared_modal_record_item05: `${$global.static}/images/study-summary/study-shared-modal-record-item05.png`,
  study_shared_modal_record_item06: `${$global.static}/images/study-summary/study-shared-modal-record-item06.png`,
  study_shared_modal_record_item07: `${$global.static}/images/study-summary/study-shared-modal-record-item07.png`,
  study_shared_modal_record_item08: `${$global.static}/images/study-summary/study-shared-modal-record-item08.png`,
  study_shared_modal_record_item09: `${$global.static}/images/study-summary/study-shared-modal-record-item09.png`,
  study_shared_modal_record_item10: `${$global.static}/images/study-summary/study-shared-modal-record-item10.png`,
  study_shared_modal_record_item11: `${$global.static}/images/study-summary/study-shared-modal-record-item11.png`,
  study_shared_modal_record_item12: `${$global.static}/images/study-summary/study-shared-modal-record-item12.png`,
  study_shared_modal_record_item13: `${$global.static}/images/study-summary/study-shared-modal-record-item13.png`,
  study_shared_modal_record_item14: `${$global.static}/images/study-summary/study-shared-modal-record-item14.png`,
  study_shared_modal_record_item15: `${$global.static}/images/study-summary/study-shared-modal-record-item15.png`,
  study_shared_modal_record_item16: `${$global.static}/images/study-summary/study-shared-modal-record-item16.png`,
  study_shared_modal_record_item17: `${$global.static}/images/study-summary/study-shared-modal-record-item17.png`,
  study_shared_modal_record_item18: `${$global.static}/images/study-summary/study-shared-modal-record-item18.png`,

  // 文房列表
  stationery_brand_story_01: `${$global.static}/images/stationery/stationery-brand-story-01-v2.png`,
  stationery_brand_story_02: `${$global.static}/images/stationery/stationery-brand-story-02-v2.png`,
  stationery_brand_story_03: `${$global.static}/images/stationery/stationery-brand-story-03-v2.png`,
  stationery_brand_story_04: `${$global.static}/images/stationery/stationery-brand-story-04.png`,
  stationery_recommend_bg: `${$global.static}/images/stationery/stationery-recommed-bg.png`,
  stationery_special_zone_sprites: `${$global.static}/images/stationery/stationery-special-zone-title-sprites.png`,
  stationery_special_zone_calligraphy_02: `${$global.static}/images/stationery/stationery-special-zone-calligraphy-02-v2.png`,
  stationery_special_zone_prepareExhibition_02: `${$global.static}/images/stationery/stationery-special-zone-prepareExhibition-02.png`,
  stationery_special_zone_chinesePaint_02: `${$global.static}/images/stationery/stationery-special-zone-chinesePaint-02.png`,
  stationery_special_zone_daycourse_02: `${$global.static}/images/stationery/stationery-special-zone-daycourse-02.png`,
  stationery_special_zone_coupon_title: `${$global.static}/images/stationery/stationery-special-zone-coupon-title.png`,
  stationery_special_zone_coupon_01: `${$global.static}/images/stationery/stationery-special-zone-coupon01.png`,
  stationery_special_zone_coupon_02: `${$global.static}/images/stationery/stationery-special-zone-coupon02.png`,
  stationery_special_zone_coupon_03: `${$global.static}/images/stationery/stationery-special-zone-coupon03.png`,
  stationery_bg_tip: `${$global.static}/images/stationery/stationery-bag-tipsv2.png`,
  stationery_address_left_bg: `${$global.static}/images/stationery/stationery-address-leftv2.png`,
  stationery_address_line: `${$global.static}/images/stationery/stationery-address-line.png`,
  stationery_address_swiper_01: `${$global.static}/images/stationery/stationery-address-bj-skpv2.png`,
  stationery_address_swiper_02: `${$global.static}/images/stationery/stationery-address-bj-dt51v2.png`,
  stationery_address_swiper_03: `${$global.static}/images/stationery/stationery-address-bj-skp-sv2.png`,
  stationery_address_swiper_04: `${$global.static}/images/stationery/stationery-address-cd-skpv2.png`,
  stationery_address_swiper_05: `${$global.static}/images/stationery/stationery-address-wh-skpv2.png`,
  stationery_address_modal_img: `${$global.static}/images/stationery/stationery-address-modal-img.png`,
  stationery_category_sprites: `${$global.static}/images/stationery/stationery-category-spritesv4.png`,
  stationery_category_tab_next_bg: `${$global.static}/images/stationery/stationery-category-tab-next-bg.png`,
  stationery_category_tab_next_btn: `${$global.static}/images/stationery/stationery-category-tab-nextbtnv2.svg`,
  stationery_qrcode_modal_bg_01: `${$global.static}/images/stationery/stationery-qrcode-modal-bg-01.png`,
  stationery_qrcode_modal_bg_02: `${$global.static}/images/stationery/stationery-qrcode-modal-bg-02.png`,
  show_review_pop_bg: `${$global.static}/images/course/h5/show-review-pop-bg.jpg`,
  show_qrcode_pop_close: `${$global.static}/images/stationery/close-qrcode-pop-btnv2.svg`,
  show_qrcode_pop_open_mini: `${$global.static}/images/stationery/open-mini-program-btn.svg`,
  show_qrcode_pop_open_mini2: `${$global.static}/images/stationery/open-mini-program-btn2.svg`,

  // 文房品牌页
  stationery_brand_bg: `${$global.static}/images/stationery/stationery-brand-bg-v2.png`,
  stationery_brand_content_left: `${$global.static}/images/stationery/stationery-brand-content-left-v2.png`,
  stationery_brand_content_right: `${$global.static}/images/stationery/stationery-brand-content-right-v2.png`,

  // 新的去上课页面
  my_layout_tabs_title_sprites: `${$global.static}/images/my-new/pc/my-title-sprites.png`,
  my_edit_name_btn: `${$global.static}/images/my-new/pc/my-classroom-edit-ico-v2.svg`,
  my_copy_btn: `${$global.static}/images/my-new/pc/my-copy-btn.svg`,
  my_classroom_card: `${$global.static}/images/my-new/pc/my-classroom-card.svg`,
  my_classroom_setting: `${$global.static}/images/my-new/pc/my-classroom-setting.svg`,
  my_classroom_title_sprites: `${$global.static}/images/my-new/pc/classroom-title-spritesv2.png`,
  my_back_btn: `${$global.static}/images/my-new/pc/my-back-btn.svg`,
  my_classroom_order: `${$global.static}/images/my-new/pc/my-classroom-order-v5.png`,
  my_classroom_coupon: `${$global.static}/images/my-new/pc/my-classroom-coupon-v5.png`,
  my_classroom_exchange: `${$global.static}/images/my-new/pc/my-classroom-exchange-v5.png`,
  my_classroom_tongban: `${$global.static}/images/my-new/pc/my-classroom-tongban-v5.png`,
  my_classroom_bishan: `${$global.static}/images/my-new/pc/my-classroom-bishan-v5.png`,
  my_classroom_pen_ico: `${$global.static}/images/my-new/pc/my-classroom-pen-ico.svg`,
  my_classroom_study_record_ico: `${$global.static}/images/my-new/pc/my-classroom-study-record-ico.svg`,
  my_classroom_study_record_right_ico: `${$global.static}/images/my-new/pc/my-classroom-study-record-right-ico.png`,
  my_classroom_calendar_ico: `${$global.static}/images/my-new/pc/my-classroom-all-calendar-ico.svg`,
  my_sticky_tab_img: `${$global.static}/images/my-new/pc/my-sticky-tab-img.png`,
  my_study_pen_ico: `${$global.static}/images/my-new/pc/my-study-tag-pen.svg`,
  my_classroom_wxpop_bg: `${$global.static}/images/my-new/pc/my-classroom-wxpop-bg.png`,
  my_classroom_wxpop_content_day: `${$global.static}/images/my-new/pc/my-classroom-wxpop-content-day.png`,
  my_classroom_wxpop_content_show: `${$global.static}/images/my-new/pc/my-classroom-wxpop-content-show.png`,
  my_classroom_wxpop_content_self: `${$global.static}/images/my-new/pc/my-classroom-wxpop-content-self.png`,
  my_classroom_wxpop_day: `${$global.static}/images/my-new/pc/my-classroom-wxpop-day-v2.png`,
  my_classroom_wxpop_show: `${$global.static}/images/my-new/pc/my-classroom-wxpop-show.png`,
  my_classroom_wxpop_self: `${$global.static}/images/my-new/pc/my-classroom-wxpop-self.png`,
  my_classroom_wxpop_scan_text: `${$global.static}/images/my-new/pc/my-classroom-wxpop-scan-text.png`,
  my_classroom_wxpop_tip_text: `${$global.static}/images/my-new/pc/my-classroom-wxpop-tip-text.png`,
  my_classroom_wxpop_bottom_line: `${$global.static}/images/my-new/pc/my-classroom-wxpop-bottom-line.png`,
  my_classroom_user: `${$global.static}/images/my-new/pc/my-classroom-user.svg`,
  header_to_my_course: `${$global.static}/images/my-new/pc/header-to-my-course.png`,
  header_to_my_homework: `${$global.static}/images/my-new/pc/header-to-my-homework.png`,
  header_to_my_order: `${$global.static}/images/my-new/pc/header-to-my-order.png`,
  my_classroom_calendar_pop_month_bg: `${$global.static}/images/my-new/pc/my-classroom-calendar-pop-month-bg.png`,
  my_classroom_calendar_pen_ico: `${$global.static}/images/my-new/pc/my-classroom-calendar-pen-ico.svg`,
  my_classroom_book_01: `${$global.static}/images/my-new/pc/my-classroom-book-01.png`,
  my_classroom_book_02: `${$global.static}/images/my-new/pc/my-classroom-book-02.png`,
  my_classroom_book_03: `${$global.static}/images/my-new/pc/my-classroom-book-03.png`,
  my_account_bishan_ico: `${$global.static}/images/my-new/pc/my-account-bishan-ico.svg`,
  my_account_bishan_ico_gray: `${$global.static}/images/my-new/pc/my-account-bishan-ico-gray.svg`,
  my_account_bishan_header_bg_img: `${$global.static}/images/my-new/pc/my-account-bishan-header-bg-img-v3.jpg`,
  my_account_bishan_go_ico: `${$global.static}/images/my-new/pc/my-account-bishan-go-ico.svg`,
  my_account_bishan_go_ico_gray: `${$global.static}/images/my-new/pc/my-account-bishan-go-ico-gray.svg`,
  my_account_coin_ico: `${$global.static}/images/my-new/pc/my-account-coin-ico.svg`,
  my_account_coin_header_bg_img: `${$global.static}/images/my-new/pc/my-account-coin-header-bg-img-v4.jpg`,
  my_settings_avatar_edit_ico: `${$global.static}/images/my-new/pc/my-settings-avatar-edit.svg`,
  my_settings_uc_usercenter_qrcode: `${$global.static}/images/my-new/pc/my-settings-uc-usercenter-qrcode.png`,
  my_classroom_calendar_list_turn: `${$global.static}/images/my-new/pc/my-classroom-calendar-list-turn.png`,
  my_classroom_student_card_bg: `${$global.static}/images/my-new/pc/my-classroom-student-card-bg.png`,
  my_student_card_unit_img: `${$global.static}/images/my-new/pc/my-student-card-unit-img.png`,
  my_classroom_course_empty_bgimg: `${$global.static}/images/my-new/pc/my-classroom-course-empty-bgimg-v3.png`,
  my_account_coin_empty_bgimg: `${$global.static}/images/my-new/pc/my-account-coin-empty-img.png`,
  my_account_bishan_empty_bgimg: `${$global.static}/images/my-new/pc/my-account-bishan-empty-img.png`,
  my_center_progress_course_title: `${$global.static}/images/my-new/pc/my-center-progress-course-title.png`,
  my_center_study_record_title: `${$global.static}/images/my-new/pc/my-center-study-record-title.png`,
  my_classroom_like_pop_bgimg: `${$global.static}/images/my-new/pc/my-classroom-like-pop-bgimg.png`,

  collage_hand: `${$global.static}/images/groupbuy/collage_hand_im.png`,
  collage_hand_success: `${$global.static}/images/groupbuy/collage_hand_success_im.png`,
  material_download_ico: `${$global.static}/images/course/pc/material-download-link-ico.svg`,

  // 桐学会
  topic_header_bg_img: `${$global.static}/images/topic/pc/topic-header-bg-img.png`,
  topic_header_polygon_img: `${$global.static}/images/topic/pc/topic-header-polygon-img.png`,
  topic_header_add_ico: `${$global.static}/images/topic/pc/topic-header-add-ico.svg`,
  topic_header_question_ico: `${$global.static}/images/topic/pc/topic-header-question-ico.png`,
  topic_header_fire_ico: `${$global.static}/images/topic/pc/topic-header-fire-ico.svg`,
  topic_header_progress_ico: `${$global.static}/images/topic/pc/topic-header-progress-ico-v2.svg`,
  topic_header_locate_img: `${$global.static}/images/topic/pc/topic-header-locate-img.png`,
  topic_header_more_city_ico: `${$global.static}/images/topic/pc/topic-header-more-city-ico.svg`,
  topic_city_header_bg_img: `${$global.static}/images/topic/pc/topic-city-header-bg-img.png`,
  topic_city_header_polygon_img: `${$global.static}/images/topic/pc/topic-city-header-polygon-img.png`,
  topic_intro_bg_img: `${$global.static}/images/topic/pc/topic-intro-bg-img.png`,
  topic_copy_btn: `${$global.static}/images/topic/pc/my-copy-btn.png`,

  topic_manager_bg_img: `${$global.static}/images/topic/pc/manager-top-bg-img-v2.png`,
  topic_rule_modal_bg_img: `${$global.static}/images/topic/pc/rule-modal-bg-img.png`,
  topic_loading_ico: `${$global.static}/images/topic/pc/loading-iconv2.png`,
  topic_locate_ico: `${$global.static}/images/common-icon/icon-loc.svg`,
  topic_empty_guild_img: `${$global.static}/images/topic/pc/empty-guild-img.png`,

  activity_calligraphy_recommend_bg_text: `${$global.static}/images/activitys/calligraphy/pc/recommend-bg-text-img.png`,
  activity_calligraphy_recommend_banner_bg: `${$global.static}/images/activitys/calligraphy/pc/recommend-banner-bg-img.png`,
  activity_calligraphy_recommend_left_paper: `${$global.static}/images/activitys/calligraphy/pc/recommend-left-paper.png`,
  activity_calligraphy_recommend_right_paper: `${$global.static}/images/activitys/calligraphy/pc/recommend-right-paper.png`,
  activity_calligraphy_introduce_bg_img: `${$global.static}/images/activitys/calligraphy/pc/introduce-bg-img.png`,
  activity_calligraphy_learn_map_bg_img: `${$global.static}/images/activitys/calligraphy/pc/learn-map-bg-img.png`,
  activity_calligraphy_learn_map_long_img: `${$global.static}/images/activitys/calligraphy/pc/learn-map-long-img.png`,
  activity_calligraphy_learn_map_title_img: `${$global.static}/images/activitys/calligraphy/pc/learn-map-title-img.png`,
  activity_calligraphy_learn_map_beginner_bg_img: `${$global.static}/images/activitys/calligraphy/pc/learn-map-beginner-bg-imgv2.png`,
  activity_calligraphy_learn_map_junior_bg_img: `${$global.static}/images/activitys/calligraphy/pc/learn-map-junior-bg-imgv2.png`,
  activity_calligraphy_learn_map_advanced_bg_img: `${$global.static}/images/activitys/calligraphy/pc/learn-map-advanced-bg-imgv2.png`,
  activity_calligraphy_learn_map_senior_bg_img: `${$global.static}/images/activitys/calligraphy/pc/learn-map-senior-bg-imgv2.png`,

  activity_calligraphy_banner_text_img: `${$global.static}/images/activitys/calligraphy/pc/banner-text-img.png`,
  activity_calligraphy_banner_cat_img: `${$global.static}/images/activitys/calligraphy/pc/banner-cat-img.png`,
  activity_calligraphy_guide_bg_img: `${$global.static}/images/activitys/calligraphy/pc/guide-bg-imgv3.png`,
  activity_calligraphy_study_system_bg_img: `${$global.static}/images/activitys/calligraphy/pc/study-system-bg-imgv2.png`,
  activity_calligraphy_study_system_tab_img1: `${$global.static}/images/activitys/calligraphy/pc/study-system-tab-img1v3.png`,
  activity_calligraphy_study_system_tab_img2: `${$global.static}/images/activitys/calligraphy/pc/study-system-tab-img2v2.png`,
  activity_calligraphy_more_learn_bg_img: `${$global.static}/images/activitys/calligraphy/pc/more-learn-bg-img.png`,
  activity_calligraphy_more_book_xssc: `${$global.static}/images/activitys/calligraphy/pc/more-book-xsscv2.png`,
  activity_calligraphy_more_book_basic: `${$global.static}/images/activitys/calligraphy/pc/more-book-basicv2.png`,
  activity_calligraphy_more_inspiration: `${$global.static}/images/activitys/calligraphy/pc/more-inspirationv2.png`,
  activity_calligraphy_more_public: `${$global.static}/images/activitys/calligraphy/pc/more-publicv2.png`,
  activity_calligraphy_book_list: `${$global.static}/images/activitys/calligraphy/pc/more-book-listv2.png`,

  activity_give_class_no: `${$global.static}/images/activitys/2026/common/give-class.png`,
  activity_coupon: `${$global.static}/images/activitys/2026/common/coupon-ico.svg`,
  activity_coin: `${$global.static}/images/activitys/2026/common/coin-ico.svg`,
  activity_2026_calligraphy_level2: {
    btn_star: `${$global.static}/images/activitys/2026/calligraphy/level2/sign-star.png`,
    learn_line: `${$global.static}/images/activitys/2026/calligraphy/level2/learn-line.svg`,
    course_bg_img: `${$global.static}/images/activitys/2026/calligraphy/level2/courses-panelv2.png`,
    course_panel_bird: `${$global.static}/images/activitys/2026/calligraphy/level2/courses-panel-bird.png`,
    course_tip_bg_img: `${$global.static}/images/activitys/2026/calligraphy/level2/courses-tip-bgimg.png`,
    top_intro_bg: `${$global.static}/images/activitys/2026/calligraphy/level2/top-intro-bg.png`,
    process_title_bg: `${$global.static}/images/activitys/2026/calligraphy/level2/process-title-bg.png`,
    course_travel_bg: `${$global.static}/images/activitys/2026/calligraphy/level2/course-travel-bgv2.png`,
    single_course_title_img: `${$global.static}/images/activitys/2026/calligraphy/level2/single-course-title-img.png`,
    welcome_ask_title_img: `${$global.static}/images/activitys/2026/calligraphy/level2/welcome-ask-title-bgv3.png`,
    welcome_ask_tab_label: `${$global.static}/images/activitys/2026/calligraphy/level2/welcome-ask-tab-label.png`,
    welcome_ask_no_basic_bg: `${$global.static}/images/activitys/2026/calligraphy/level2/no-basic-tab-bg.png`,
    welcome_ask_uninsist_bg: `${$global.static}/images/activitys/2026/calligraphy/level2/uninsist-tab-bg.png`,
    welcome_ask_how_xt_title: `${$global.static}/images/activitys/2026/calligraphy/level2/how-xt-tab-bg.png`
  }
}
